import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-settings-3-line',
    title: 'Sondermaschinenbau',
    description: 'Entwicklung und Fertigung von Sondermaschinen nach Ihren spezifischen Anforderungen – von der Konzeption bis zur Inbetriebnahme.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Steuerungstechnik / SPS',
    description: 'Programmierung und Integration von SPS-Systemen (Siemens, Beckhoff, OMRON) für komplexe Automatisierungsaufgaben.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-robot-line',
    title: 'Automation & Handling',
    description: 'Planung und Umsetzung vollautomatischer Handlingsysteme, Roboterintegration und Fördertechnik für Ihre Produktion.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-eye-line',
    title: 'Bildverarbeitung',
    description: 'Industrielle Bildverarbeitungssysteme zur Qualitätssicherung, Fehlererkennung und Prozessoptimierung in der Fertigung.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-tools-line',
    title: 'Mechanische Fertigung',
    description: 'CNC-Fräsen, Draht- und Senkerodieren sowie Baugruppen- und Vorrichtungsfertigung in höchster Präzision.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Hard- & Softwareentwicklung',
    description: 'Kundenspezifische Hard- und Softwarelösungen für Maschinen, Prüfplätze und Automatisierungssysteme aus einer Hand.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Lasertechnik',
    description: 'Präzises Laserschneiden, -schweißen, -markieren und -gravieren für Metall, Kunststoff und Verbundwerkstoffe.',
    color: 'text-[#1E3A8A]',
    bg: 'bg-[#EFF6FF]',
  },
];

const ServicesOverview = () => {
  return (
    <section id="leistungen" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Was wir tun</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">Unsere Kernkompetenzen</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Von der Idee bis zur fertigen Anlage – wir begleiten Ihr Projekt mit technischer Kompetenz und persönlichem Einsatz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-white border border-gray-100 rounded-xl p-8 hover:border-[#1E3A8A]/20 hover:shadow-md transition-all duration-300 cursor-default"
            >
              <div className={`w-14 h-14 flex items-center justify-center ${service.bg} rounded-xl mb-6`}>
                <i className={`${service.icon} ${service.color} text-2xl`}></i>
              </div>
              <h3 className="text-gray-900 font-semibold text-lg mb-3 leading-snug">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 text-[#1E3A8A] font-semibold text-sm hover:gap-3 transition-all duration-200 cursor-pointer"
          >
            Alle Leistungen im Detail
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
